import {useTranslation} from "react-i18next";
import {Divider, Grid, Stack, Textarea, TextInput} from "@mantine/core";
import {useCustomFieldProfileFormContext} from "./useCustomFieldProfileForm";
import {CustomFieldProfileFormProps} from "./CustomFieldProfileForm";
import {CompanySelect} from "../../select/entity/CompanySelect/CompanySelect";
import {EntityTypeSelect} from "../../select/entity/EntityTypeSelect/EntityTypeSelect";
import {DateInput} from "../../date/DateInput/DateInput";
import {CustomFieldProfileCatalogItem} from "@ots-frontend/ots-data";
import {CustomFieldProfileFieldPicker} from "./CustomFieldProfileFieldPicker";

export type CustomFieldProfileFormFieldProps = Pick<CustomFieldProfileFormProps, 'options'> & {
  catalog: CustomFieldProfileCatalogItem[]
  setCatalog: (catalog: CustomFieldProfileCatalogItem[]) => void
}

export const CustomFieldProfileFormFields = (props: CustomFieldProfileFormFieldProps) => {
  const {
    options,
    catalog,
    setCatalog,
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useCustomFieldProfileFormContext();

  return (
    <Grid>
      <Grid.Col span={6}>
        <Stack>
          <Grid>
            <Grid.Col span={6}>
              <CompanySelect
                size="xs"
                label={t("common.entity.customfieldprofile.form.field.company", "Company")}
                placeholder={t<string>("common.entity.customfieldprofile.form.field.company.placeholder", "Company")}
                disabled={options?.companySelectDisabled}
                selector={{
                  regionId: options?.regionId,
                }}
                withAsterisk
                required
                clearable
                {...form.getInputProps("company")} />
            </Grid.Col>
            <Grid.Col span={6}>
              <EntityTypeSelect
                size="xs"
                label={t("common.entity.customfieldprofile.form.field.objecttype", "Entity Type")}
                placeholder={t<string>("common.entity.customfieldprofile.form.field.objecttype.placeholder", "Entity Type")}
                withAsterisk
                required
                clearable
                {...form.getInputProps("objectType")} />
            </Grid.Col>
          </Grid>

          <Divider label="" labelPosition="left" variant="dotted" mt="md" mb="sm"/>

          <TextInput
            size="xs"
            label={t("common.entity.customfieldprofile.form.name.label", "Name")}
            placeholder={t<string>("common.entity.customfieldprofile.form.field.name.placeholder", "DVIR Custom Fields")}
            withAsterisk
            required
            {...form.getInputProps('name')}/>

          <Textarea
            size="xs"
            label={t("common.entity.customfieldprofile.form.desc.label", "Description")}
            placeholder={t<string>("common.entity.customfieldprofile.form.field.desc.placeholder", "A custom field profile for our custom DVIR fields.")}
            minRows={4}
            autosize
            withAsterisk
            required
            {...form.getInputProps('description')} />

          <Divider label="Effectivity" labelPosition="left" variant="dotted" mt="md" mb="sm"/>

          <DateInput
            size="xs"
            label={t("common.entity.customfieldprofile.form.field.effectivefrom", "Effective From")}
            valueFormat="MM/DD/YYYY HH:mm"
            clearable
            withAsterisk
            required
            {...form.getInputProps('effectiveFromDate')}/>

          <DateInput
            size="xs"
            label={t("common.entity.customfieldprofile.form.field.effectiveto", "Effective To")}
            valueFormat="MM/DD/YYYY HH:mm"
            clearable
            {...form.getInputProps('effectiveToDate')}/>
        </Stack>

      </Grid.Col>

      <Grid.Col span={6}>
        <Divider label="Fields" labelPosition="left" variant="dotted" mt="md" mb="sm"/>
        <CustomFieldProfileFieldPicker
          options={options}
          catalog={catalog}
          setCatalog={setCatalog}/>
      </Grid.Col>


    </Grid>
  )
}
